define('module/form',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub'
], function($,_,Cnf, Pubsub) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub;

        this.options={
            selector:{
                form:'form.form',
                submit:'[type="submit"], .button-submit',
                msg:'.msg',
                redirect:'.redirect',
                toggle: '[data-toggleform]',
                toggleParent: 'div',
                toggleGrandParent: '.ce-form'
            },
            data:{
                granted:'granted'
            },
            className:{
                disabled:'disabled'
            },
            attr:{
                error:'data-error'
            },
            formatAbonumber:{
                array:4,
                section:3,
                delimiter:'   '
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initForm();
            this.initListener();
            this.initToggle();
        };
        
        this.initOptions=function()
        {
            this.oForm={};
            this.$form=Cnf.$app.find(this.options.selector.form);
            this.iForm=this.$form.length;
            
            //set toggle
            this.$toggle = Cnf.$app.find(this.options.selector.toggle);
        };
        
        this.initForm=function()
        {
            if(this.iForm<=0) {
                return;
            }
            
            var $form;
            for(var i=0;i<this.iForm;i++) {
                $form=this.$form.eq(i);
                $form.on('submit',_.bind(this.submit,this,i));
                this.oForm[i]={
                    $form:$form,
                    $input:$form.find(':input'),
                    $submit:$form.find(this.options.selector.submit),
                    $msg:$form.find(this.options.selector.msg),
                    $redirect:$form.find(this.options.selector.redirect),
                    busy:false,
                    type:$form.data('type')
                };
                
                //show redirect button if access is granted
                /**
                 * disable instant display since FDZ-53
                 * if(this.oForm[i].$redirect.data(this.options.data.granted)===1) {
                    this.showRedirect(i);
                }
                **/
            }
        };
        
        /**
         * fetch custom elements to bind event listener
         * 
         * @returns {undefined}
         */
        this.initListener=function()
        {
            if(this.iForm<=0) {
                return;
            }
            
            for(var i=0;i<this.iForm;i++) {
                
                //iterate through all form elements
                for(var k=0,l=this.oForm[i].$input.length;k<l;k++) {
                    
                    //fetch format trigger
                    switch(this.oForm[i].$input.eq(k).data('format')) {
                        case 'abonumber':
                            this.oForm[i].$input.eq(k)
                                    .val(this.getFormattedAbonumber(this.oForm[i].$input.eq(k).val()))
                                    .addClass('is-formatted')
                                    .attr('placeholder', _.map(new Array(this.options.formatAbonumber.section), _.bind(function(){
                                        return "X".repeat(this.options.formatAbonumber.array);
                                    },this),this).join(this.options.formatAbonumber.delimiter))
                                    .on('keydown', _.partial(this.onKeyDownAbonumber,this))
                                    .on('keydown', _.partial(this.formatAbonumber,this))
                                    .on('keyup', _.partial(this.formatAbonumber,this))
                                    .on('paste', _.partial(this.formatAbonumberDelayed,this));
                            break;
                            
                        default:break;
                    }
                }
            }
        };
        
        /**
         * get raw abonumber
         * 
         * @param {type} value
         * @returns {unresolved}
         */
        this.getRawAbonumber=function(value)
        {
            var oRegex=new RegExp("[^0-9]","g");
            
            return value.replace(oRegex,'');
        };
        
        /**
         * manipulate given value against abonumber format
         * 
         * @param {type} value
         * @param {type} keycode
         * @returns {String}
         */
        this.getFormattedAbonumber=function(value, keycode)
        {
            var sReturn='',
                    rawVal=this.getRawAbonumber(value),
                    oRegexSection=new RegExp(".{1," + this.options.formatAbonumber.array + "}", "g"),
                    aVal=rawVal.match(oRegexSection),//split into array items by given length
                    bAppendOnLast=true;
            
            //handle special keycodes prior manipulation
            switch(keycode) {
                //backspace
                case 8:
                    bAppendOnLast=false;
                    break;
                    
                default:break;
            }
            
            //manipulate input value
            if(rawVal.length>0) {
                _.each(aVal,function(val,index) {
                    sReturn+=val;
                    //append delimiter after section length
                    if(
                            (val.length===this.options.formatAbonumber.array)
                            && (index<(this.options.formatAbonumber.section-1))
                            && (
                                (true===bAppendOnLast)
                                || (aVal.length>(index +1))
                            )
                    ) {
                        sReturn+=this.options.formatAbonumber.delimiter;
                    }
                },this);
            }
            
            return sReturn;
        };
        
        /**
         * format abonumber on keydown/up/paste to given element
         * 
         * @param {type} _this
         * @param {type} ev
         * @returns {undefined}
         */
        this.formatAbonumber=function(_this,ev)
        {
            var iSelectionStart=this.selectionStart,
                    iInitialLength=ev.currentTarget.value.length;
            
            ev.currentTarget.value=_.bind(_this.getFormattedAbonumber,_this,ev.currentTarget.value, ev.keyCode)();
            
            //handle special keycodes after value manipulation
            switch(ev.keyCode) {
                //backspace
                case 8:
                //del
                case 46:
                    this.setSelectionRange(iSelectionStart,iSelectionStart);
                    break;
                    
                //0-9
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                    //insert number before the end
                    if(iSelectionStart<iInitialLength) {
                        this.setSelectionRange(iSelectionStart,iSelectionStart);
                    } else {
                        this.setSelectionRange(Math.max(iSelectionStart, ev.currentTarget.value.length),Math.max(iSelectionStart, ev.currentTarget.value.length));
                    }
                    break;
                    
                default:break;
            }
        };
        
        /**
         * trigger format abonumber by delay, for use on touch device
         * 
         * @param {type} _this
         * @param {type} ev
         * @returns {undefined}
         */
        this.formatAbonumberDelayed=function(_this,ev)
        {
            _.delay(_.bind(_this.formatAbonumber,this,_this,ev),100);
        };
        
        /**
         * callback on keydown for abonumber
         * 
         * @param {type} _this
         * @param {type} ev
         * @returns {Boolean}
         */
        this.onKeyDownAbonumber=function(_this,ev)
        {
            var rawVal=_this.getRawAbonumber(ev.currentTarget.value),
                    bBreak,
                    iSelectionStart=this.selectionStart;
            
            //mark break on max length
            if(rawVal.length>=(_this.options.formatAbonumber.array *_this.options.formatAbonumber.section)) {
                switch(ev.keyCode) {
                    case 8://backspace
                    case 9://tab
                    case 13://enter
                    case 17://ctrl
                    case 27://escape
                    case 35://end
                    case 36://pos1
                    case 37://prev
                    case 39://next
                    case 46://del
                        bBreak=false;
                        break;

                    default:
                        bBreak=true;
                        break;
                }
            } else {
                //block several chars
                switch(true) {
                    case (ev.keyCode>=65 && ev.keyCode<=90)://a-z
                    case (ev.keyCode>=186 && ev.keyCode<=191)://ü+,-.#ö
                    case (ev.keyCode>=219&& ev.keyCode<=222)://ß^´ä
                    case ev.keyCode===226://<
                        bBreak=true;
                        break;

                    default:break;
                }
            }
            
            //enable ctrl + a|c|x|...
            if(true===(ev.ctrlKey||ev.metaKey)) {
                bBreak=false;
            }
            
            if(true===bBreak) {
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            }
            
            //manipulate selection on prev/nex
            switch(ev.keyCode) {
                case 37://prev
                    if(_this.options.formatAbonumber.delimiter.length===(iSelectionStart +_this.options.formatAbonumber.delimiter.length) % (_this.options.formatAbonumber.array + _this.options.formatAbonumber.delimiter.length)) {
                        iSelectionStart+=((_this.options.formatAbonumber.delimiter.length) -1) *-1;
                        this.setSelectionRange(Math.max(0,iSelectionStart),Math.max(0,iSelectionStart));
                    }
                    break;
                    
                case 39://next
                    if(0===(iSelectionStart +_this.options.formatAbonumber.delimiter.length) % (_this.options.formatAbonumber.array + _this.options.formatAbonumber.delimiter.length)) {
                        iSelectionStart+=(_this.options.formatAbonumber.delimiter.length) -1;
                        this.setSelectionRange(iSelectionStart,iSelectionStart);
                    }
                    break;

                default:break;
            }
        };
        
        
        /**
         * callback on submit
         * 
         * @param {type} index
         * @param {type} ev
         * @returns {undefined}
         */
        this.submit=function(index,ev)
        {
            ev.preventDefault();
            
            if(this.oForm[index].busy!==false) {
                return;
            }
            this.oForm[index].busy=true;
            this.oForm[index].$submit.addClass('pending');
            
            //update dom
            this.oForm[index].$form.addClass(this.options.className.disabled);
            var sContent = '&nbsp;';
            if(this.oForm[index].type=='newsletter-popup') {
                sContent = '';
            }
            this.oForm[index].$msg.html('<div ' + this.options.attr.error + '="false">' + sContent + '</div>');
            
            //validate field requirements
            var aForm=_.map($(ev.currentTarget).find('[name]'), _.bind(function(item, index, list) {
                
                var value=list.eq(index).val();

                //format dependend of input type
                switch(item.type) {
                    case 'checkbox':
                    case 'CHECKBOX':
                        value = (true === item.checked) ? 1 : 0;
                        break;

                    default: break;
                }
                
                //format special input to appropriate format
                switch(list.eq(index).data('format')) {
                    case 'abonumber':
                        value=this.getRawAbonumber(value);
                        break;
                        
                    default:break;
                }
                
                return {
                    item: item,
                    name:list.eq(index).attr('name'),
                    value:value,
                    type: item.type,
                    required:list.eq(index).attr('required') && !list.eq(index).attr('disabled') ? true : false
                };
            },this));
            
            var bRequired=_.every(aForm,function(item) {
                var bReturn=false;
                
                switch(true) {
                    case true===item.required:
                        switch(item.type) {
                            case 'checkbox':
                            case 'CHECKBOX':
                                if(item.value === 1) {
                                    bReturn = true;
                                }
                                break;
                            
                            default:
                                if(item.value.length>0) {
                                    bReturn=true;
                                }
                                break;
                        }
                        break;
                        
                    case false===item.required:
                        bReturn=true;
                        break;
                }
                
                return bReturn;
            });
            
            //A) requirements are met
            if(true===bRequired) {
                var aData={};
                for(var key in aForm) {
                    aData[aForm[key].name]=aForm[key].value;
                }
                
                $.ajax({
                    url:window.cnf.host + window.cnf.api,
                    dataType:'json',
                    method:'post',
                    data: aData,
                    complete:_.bind(function(index,xhr) {
                        try {
                            //reset form
                            this.oForm[index].busy=false;
                            this.oForm[index].$submit.removeClass('pending');
                            this.oForm[index].$form.removeClass(this.options.className.disabled);
                            this.oForm[index].$msg.html('');
                            _.each(xhr.responseJSON.success, _.bind(function(msg){
                                var oArg={html:msg};
                                oArg[this.options.attr.error]='false';
                                $('<div/>', oArg).appendTo(this.oForm[index].$msg);
                            },this));
                            
                            //prepend subheadline to error
                            if(
                                    (Object.keys(xhr.responseJSON.success).length>0)
                                && (Object.keys(xhr.responseJSON.error).length>0)
                            ) {
                                $('<div class="msg-subheadline">Hinweis:</div>').appendTo(this.oForm[index].$msg);
                            }
                            
                            _.each(xhr.responseJSON.error, _.bind(function(msg){
                                var oArg={html:msg};
                                oArg[this.options.attr.error]='true';
                                $('<div/>', oArg).appendTo(this.oForm[index].$msg);
                            },this));
                            
                            //renew token if given
                            if(typeof xhr.responseJSON.token!=='undefined') {

                                _.each(xhr.responseJSON.token, _.bind(function(token,name) {
                                    this.oForm[index].$input.filter('[name="' + name + '"]').attr('value', token);
                                },this));
                            }

                            //reset form if given
                            if(xhr.responseJSON.empty_on_success === true) {
                                _.each(aForm, function(item) {
                                    switch(item.type) {
                                        case 'hidden':
                                        case 'HIDDEN':
                                        case 'submit':
                                        case 'SUBMIT':
                                            //maintain values
                                            break;
                                        
                                        case 'checkbox':
                                        case 'CHECKBOX':
                                            item.item.checked = false;
                                            break;
                                        
                                        default:
                                            item.item.value = "";
                                            break;
                                    }
                                });
                            }

                            //@jira FDZ-677: trigger hide nl popup
                            if(xhr.responseJSON.status === 200) {
                                oPubsub.trigger(Pubsub.HIDE_NL_POPUP);
                            }

                            //trigger on complete
                            this.onComplete({index:index, action:aData.action, success:xhr.responseJSON.success, error:xhr.responseJSON.error});
                        } catch(e) {
                            console.log(e);

                            //send log
                            $.ajax({
                                url: window.cnf.host + window.cnf.api,
                                dataType: 'json',
                                type: 'post',
                                data: {
                                    action: 'log',
                                    error: e,
                                    origin: 'form::submit()',
                                    items: aData,
                                    responseText: xhr.responseText
                                }
                            });

                            this.oForm[index].$form.removeClass(this.options.className.disabled);
                            this.oForm[index].$msg.html('<div ' + this.options.attr.error + '="true">Es ist ein Fehler aufgetreten. Versuchen Sie es zu einem späteren Zeitpunkt erneut (code 8i8us).</div>');
                        }
                    }, this, index)
                });
                
            //B) fail
            } else {
                _.delay(_.bind(function() {
                    this.oForm[index].busy=false;
                    this.oForm[index].$submit.removeClass('pending');
                    this.oForm[index].$form.removeClass(this.options.className.disabled);
                    this.oForm[index].$msg.html('<div ' + this.options.attr.error + '="true">Pflichtfelder müssen ausgefüllt sein</div>');
                },this),1000);
            }
        };
        
        this.onComplete=function()
        {
            /**
             * @see FDZ-445
             * show redirect on success, ignore error
             * 
            if(
                    (false===arguments[0].error)
                    || (
                        (typeof arguments[0].error==='object')
                        && (arguments[0].error.length===0)
                    )
            ) {
             */
            if(
                (typeof arguments[0].success==='object')
                && (arguments[0].success.length>0)
            ) {
                switch(arguments[0].action) {
                    case window.cnf.action.profile:
                        this.showRedirect(arguments[0].index);
                        break;

                    case window.cnf.action.nl_subscribe:
                        this.resetForm(arguments[0].index);
                        break;

                    default:break;
                }
            }
        };
        
        this.showRedirect=function(index)
        {
            this.oForm[index].$redirect.addClass('show');
        };
        
        this.resetForm=function(index)
        {
            _.each(this.oForm[index].$form.find('input[type="text"], input[type="email"], input[type="checkbox"]'), function(item) {
                switch(item.type) {
                    case 'text':
                    case 'email':
                        item.value='';
                        break;
                        
                    case 'checkbox':
                        item.checked=false;
                        break;
                }
            });
        };

        /**
         * init toggle
         */
        this.initToggle = function()
        {
            if(this.$toggle.length>0) {
                _.each(this.$toggle, _.bind(this.showForm, this));
            }
        }

        /**
         * show form by given index
         * 
         * @param {object} item 
         * @param {int} index 
         */
        this.showForm = function(item, index)
        {
            this.$toggle.eq(index).on('click', _.bind(function(toggleindex) {
                
                var $src = this.$toggle.eq(toggleindex),
                    $parent = $src.closest(this.options.selector.toggleParent),
                    $grandParent = $src.closest(this.options.selector.toggleGrandParent),
                    $target = $grandParent.find('[data-toggletarget="' + $src.data('toggleform') + '"]'),
                    iHeight = $grandParent.outerHeight(true);

                $src.off('click');
                TweenMax.to($grandParent, .5, {'min-height': iHeight});
                TweenMax.to($src, .5, {
                    autoAlpha: 0,
                    onComplete: function() {
                        $parent.css('display', 'none');
                    }
                });
                TweenMax.set($target, {height: 'auto', autoAlpha: 1});
                TweenMax.from($target, .5, {
                    height: 0,
                    autoAlpha: 0,
                    ease: Power1.easeInOut,
                    delay: .5,
                    onComplete: _.bind(function() {
                        $grandParent.css('min-height', 'auto');
                    }, this)
                });
                
            }, this, index));
        }
        
        this.init();
    };
});
